// extracted by mini-css-extract-plugin
export default {"preview":"index_preview__4UNWt","tips":"index_tips__ixPwO"};